var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrong-network-container"},[_c('div',{staticClass:"title"},[_vm._v("Wrong network")]),_c('div',{staticClass:"suggest"},[_vm._v(" Please switch to "),_c('pre',[_vm._v(_vm._s(_vm.config.configWallet.chainName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }